import {
    Zap,
    TrainFront,
    ShieldCheck,
    RadioTower,
    Landmark,
    Navigation
} from "lucide-react";

const SectorsServed = () => {
    const sectors = [
        {
            label: "Highways & Expressways",
            icon: <Navigation size={40} strokeWidth={1.5} />,
            description: "Supplying steel for robust infrastructure networks."
        },
        {
            label: "Hydro Power Plants",
            icon: <Zap size={40} strokeWidth={1.5} />,
            description: "High-grade materials for energy generation projects."
        },
        {
            label: "Railways Bridges & Tunnels",
            icon: <TrainFront size={40} strokeWidth={1.5} />,
            description: "Trusted partner for national railway expansion."
        },
        {
            label: "Bridges & Construction Projects",
            icon: <Landmark size={40} strokeWidth={1.5} />,
            description: "Structural steel for durable and iconic bridges."
        },
        {
            label: "Power Grids & Transmission",
            icon: <RadioTower size={40} strokeWidth={1.5} />,
            description: "Supporting the backbone of power distribution."
        },
        {
            label: "Defence Projects",
            icon: <ShieldCheck size={40} strokeWidth={1.5} />,
            description: "Certified quality for critical defence infrastructure."
        }
    ];

    return (
        <section className="py-24 bg-slate-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="text-accent font-bold tracking-wide uppercase text-sm mb-3">Industries</h2>
                    <h3 className="text-3xl md:text-5xl font-bold font-heading text-primary mb-6">
                        Sectors Served
                    </h3>
                    <p className="text-slate-600 text-lg">
                        We are proud to contribute to the nation's growth by serving critical infrastructure and development sectors.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {sectors.map((sector, idx) => (
                        <div
                            key={idx}
                            className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 flex flex-col items-center text-center group"
                        >
                            <div className="mb-6 p-4 bg-slate-50 rounded-full text-primary group-hover:bg-accent group-hover:text-white transition-colors duration-300">
                                {sector.icon}
                            </div>
                            <h4 className="text-xl font-bold font-heading text-primary mb-3">
                                {sector.label}
                            </h4>
                            <p className="text-slate-500 text-sm leading-relaxed">
                                {sector.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SectorsServed;
